import { useEffect, useRef } from 'react';

const useLoseFocusOnHover = ref => {
  const stateRef = useRef(false);
  const _ref = useRef();

  useEffect(() => {
    if (ref?.current || _ref.current) {
      const element = ref?.current ?? _ref.current;
      const hoverHandler = () => (stateRef.current = true);
      const unhoverHandler = () => (stateRef.current = false);
      const blur = () => stateRef.current && element.blur?.();
      element.addEventListener('mouseenter', hoverHandler);
      element.addEventListener('mouseleave', unhoverHandler);
      element.addEventListener('click', blur);
      return () => {
        element.removeEventListener('mouseenter', hoverHandler);
        element.removeEventListener('mouseleave', unhoverHandler);
        element.removeEventListener('click', blur);
      };
    }
  }, [ref]);

  return _ref;
};

export default useLoseFocusOnHover;
